export default ".tb-border {\n  border: 1px solid black;\n}\n\n.txt-bold {\n  font-weight: bold;\n}";